module.exports = __webpack_public_path__ + "static/media/folder_icon.a40c9c4a.svg";